(ns teamoesterreich.admin-mode.ui-helper.image-drop-upload
  (:require
    [reagent.core :as r]
    [teamoesterreich.admin-mode.data.backend :as backend]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.ajax :as ajax]
    ))


(defn >upload-image [url {:keys [name buffer content-type width max-width max-height on-finish] :as props}]
  (let [url (str url "?width=" width "&max-height=" max-height "&max-width=" max-width)]
    (log/out "UPLOAD" url props)
    (ajax/post-file> url buffer
                     name content-type
                     on-finish)))


(defn get-it [actual-url on-uploaded-fn & [options]]
  (let [!st (r/atom {})
        upload-url (str backend/BASE_URL "/media-upload")
        upload-file-fn (fn [file]
                         (let [fr (js/FileReader.)]
                           (set! (.-onload fr)
                                 (fn [event]
                                   ;(log/out "read file" event (.. event -target -result))
                                   (>upload-image upload-url {:buffer       (.. event -target -result)
                                                              :name         (.-name file)
                                                              :width        (:width options)
                                                              :max-width    (or (:max-width options) 420)
                                                              :max-height   (or (:max-height options) 800)
                                                              :content-type (.-type file)
                                                              :on-finish    (fn [res-url]
                                                                              (log/out "got back URL" res-url)
                                                                              (when on-uploaded-fn (on-uploaded-fn res-url)))})))
                           (.readAsArrayBuffer fr file)))]
    (fn []
      (let []
        [:div {:style       {:border              (if (:dragEntered @!st) "2px dotted #f44" "2px dotted #444")
                             :height              "150px" :margin "10px"
                             :max-width           "564px"
                             :background          "#eef0ee"
                             :background-size     "contain"
                             :background-repeat   "no-repeat"
                             :background-position "center"
                             :background-image    (when actual-url (str "url(" actual-url ")"))
                             :text-shadow         "    -1px -1px 0 #eee,                 1px -1px 0 #eee,                 -1px 1px 0 #eee,                 1px 1px 0 #eee"
                             :text-align          "center" :padding-top "60px"}

               :onPaste     (fn [e]
                              ;(js/console.log "pasted!!!", (.-clipboardData e), (.-items (.-clipboardData e)))
                              (doseq [item_ (array-seq (.-items (.-clipboardData e)))]
                                (do
                                  ;(js/console.log "pasted Item!!!", (.-kind item_))
                                  (case (.-kind item_)
                                    "file" (upload-file-fn (.getAsFile item_)) ;(js/console.log "pasted File!!!", (.getAsFile item_))
                                    ;"string" (js/console.log "pasted String!!!", (.getAsString item_))
                                    ;"text/html" (js/console.log "pasted String!!!", (.getAsString item_))
                                    ;"text/plain" (js/console.log "pasted String!!!", (.getAsString item_))
                                    ;(js/console.log "Unknown Type:", (.-kind item_))
                                    ))))

               :onDragEnter (fn [e] (swap! !st assoc :dragEntered true) (.preventDefault e))
               :onDragOver  (fn [e] (swap! !st assoc :dragEntered true) (.preventDefault e))
               :onDragLeave (fn [e] (swap! !st assoc :dragEntered false))
               :onDrop      (fn [event]
                              ;(log/out "dropped!!! " upload-url event)
                              (.preventDefault event)
                              (.stopPropagation event)
                              (when-let [files (array-seq (.. event -dataTransfer -files))]
                                ;(log/out "got file" files)
                                (upload-file-fn (first files)))
                              (swap! !st assoc :dragEntered false)
                              false)
               }
         (or (:text options) (str "Ziehen Sie ihr Bild hier herein!!\n"
                                  ;"url=" @actual-url-cs
                                  ))]
        ))))